import { FAQ_DETAILS, FAQ_TOPIC_SHORT } from "../../gql/StaticPagesQueris";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";
import FaqSearch from "../FAQSearchField";

export default {
  name: "faq_details",

  data() {
    return {
      routeParams: {},
      faq: [],
      faqTopic: []
    };
  },

  apollo: {
    faq: {
      query: FAQ_DETAILS,
      variables() {
        return {
          id: Number(this.$route.params.topicId)
        };
      }
    },

    faqTopic: {
      query: FAQ_TOPIC_SHORT,
      variables() {
        return {
          faqTopicId: Number(this.$route.params.id)
        };
      }
    }
  },

  mounted: function() {
    this.routeParams = this.$route.params;
  },

  methods: {},

  components: {
    LoadingIcon,
    FaqSearch
  }
};
